export default "__VITE_ASSET__CZK3AWVx__"